var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingAssignedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "custom-user-check-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-user-check"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-user-check",
    width: 24,
    height: 24,
    transform: "translate(720.108 44)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-group-user-check",
    transform: "translate(-720.108 -44)",
    clipPath: "url(#clip-path-user-check)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-user-check-outline",
    transform: "translate(724.984 49.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-user-check",
    d: "M46.248,28.5l-2.4,2.4-1.35-1.35M35,33h6a3,3,0,0,1,3,3v1.5H32V36A3,3,0,0,1,35,33Zm6-6a3,3,0,1,1-3-3A3,3,0,0,1,41,27Z",
    transform: "translate(-32 -24)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    className: "path-user-check"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingAssignedIcon);
export default __webpack_public_path__ + "static/media/ticketing-assigned-icon.00917a7639f9a61a3f0a7a8f7d4466af.svg";
export { ForwardRef as ReactComponent };